import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserDetailsLayoutComponent } from './user-details-layout/user-details-layout.component';
import { SharedModule } from '../shared/shared.module';
import { UserRoutingModule } from './user-routing.module';
import { MaterialModule } from '../shared/material.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AngularFirestore } from '@angular/fire/firestore';
import { UserService } from './user.service';
import { MyProfileIncompleteComponent } from './my-profile-incomplete/my-profile-incomplete.component';

@NgModule({
  declarations: [UserDetailsLayoutComponent, MyProfileIncompleteComponent],
  imports: [
    CommonModule,
    SharedModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    UserRoutingModule
  ],
  providers: [AngularFirestore, UserService],
  exports: [MyProfileIncompleteComponent]
})
export class UserModule {}
